import { IntlShape } from 'react-intl';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { ErrorPresentation } from 'helpers/validators';

export function formatFieldError(
  intl: IntlShape,
  error?: ErrorPresentation
): string | undefined {
  if (!error) {
    return undefined;
  }

  return formatTranslation(intl, unsafeTranslationKey(error.helperText.id) , error.values);
}
